/**
 * Sticky Navigation Scripts
 *
 * Global component hence it's own file. 
 * 
 * Don't check if 
 *
 * @package   seedyjoints
 * @since     JointsWP
 * @author    <john@chatmandesign.com>
 * @link      http://chatmandesign.com
 */

(function($) {
	let headerSelector  = '#theme-header';
    let compactClass    = 'compact';
    let hoveredClass    = 'is-hovered';

    let hamburgerMenu   = headerSelector + ' .main-hamburger';

    let searchDisplay   = '.search-display';
    let searchForm      = searchDisplay + '__form';
    let searchClose     = searchForm + ' .close > span';
    let searchIcon      = searchDisplay + '__icon';

    let searchOpen      = false;
    
    function cd_compact_header(scrollTop) {
		if(scrollTop >= scrollPoint) {
			$(headerSelector).addClass(compactClass);
		} else {
			$(headerSelector).removeClass(compactClass);
		}
    }

    let headerHeight    = 0;
    let scrollPoint     = 0;

    // DOM READY
    $(function() {
        // Add Margin for sticky header
		// Timeout for final header height
		setTimeout(function() {
			headerHeight = $(headerSelector).outerHeight();
            scrollPoint = headerHeight / 4; // Make header compact at 1/4 scroll distance of header
            cd_compact_header($(window).scrollTop()); // Checks if someone is already past point on load
        }, 1);

        // Want to restore full header on hover
		// Need to check to make sure it doesn't already have the class
		$(headerSelector).hover(
			function (event){
				$(this).addClass(hoveredClass);
				if( $(this).hasClass(compactClass) ){
					$(this).removeClass(compactClass);
				}
			},
			function() {
                if( !searchOpen ) {
                    $(this).removeClass(hoveredClass);
                    cd_compact_header($(window).scrollTop());
                }
			}
        );
        
        $(searchIcon).on('click', function(e) { 
            $(headerSelector).removeClass(compactClass);
            $(headerSelector).addClass(hoveredClass);
            searchOpen = true;
        });

        $(searchClose).on('click', function(e) { 
            cd_compact_header($(window).scrollTop());
            $(headerSelector).removeClass(hoveredClass);
            searchOpen = false;
        });

        $(hamburgerMenu).on('click', function(e) { 
            cd_compact_header($(window).scrollTop());
            $(headerSelector).removeClass(hoveredClass);
        });

        // ON SCROLL
		$(window).scroll(function(){
            if( !$(headerSelector).hasClass(hoveredClass) ){
				cd_compact_header($(window).scrollTop());
			}
        });
        
    }); // DOM ready

})(jQuery);